import { useRouteMatch } from 'react-router';

export enum ASSIGNMENT_TYPE {
  TRAVEL = 'travel',
  ASSIGNMENT = 'assignment',
  PER_DIEM = 'per_diem',
  PERMANENT_PLACEMENT = 'permanent_placement',
}

const useAssignmentType = (): ASSIGNMENT_TYPE => {
  const { url } = useRouteMatch();

  switch (url) {
    case '/available/assignments/travel':
      return ASSIGNMENT_TYPE.TRAVEL;
    case '/available/assignments/local':
      return ASSIGNMENT_TYPE.ASSIGNMENT;
    case '/available/jobs':
      return ASSIGNMENT_TYPE.PER_DIEM;
    case '/available/permanent-placements':
      return ASSIGNMENT_TYPE.PERMANENT_PLACEMENT;
  }
};

export default useAssignmentType;
